import {
    Box,
    Button,
    Flex,
    IconButton,
    Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import Select from "react-select";
import { attendanceReportRequest } from "../../../modules/superadmin-modules/reports/Actions";
import { getAllLecturesRequest } from "../../../modules/admin-modules/lectures/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { getManualExamsRequest } from "../../../modules/superadmin-modules/exams/Actions";
import { getManualExamsMarksRequest } from "../../../modules/superadmin-modules/exams/Actions";
import { setManualExamMarkRequest } from "../../../modules/superadmin-modules/exams/Actions";

const AttendanceSimpleReport = ({ setAdd }) => {
    const dispatch = useDispatch();
    const [lecId, setLecId] = useState("");
    const [date, setDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));
    const [examId, setExamId] = useState("");

    const user = useSelector((state) => state.user.userData);

    const [marks, setMarks] = useState([]); // Add state for marks
    const [scores, setScores] = useState({}); // Replace single score state with scores object

    // Get marks from Redux store
    const examMarks = useSelector((state) => state.superadminExams.marks);

    // Watch for marks changes
    useEffect(() => {
        if (examMarks && examMarks.length > 0) {
            setMarks(examMarks);
        }
    }, [examMarks]);

    useEffect(() => {
        if (lecId) dispatch(attendanceReportRequest(lecId, date));
    }, [lecId, date]);

    useEffect(() => {
        dispatch(getAllLecturesRequest());
        dispatch(getManualExamsRequest());
    }, []);

    const getMarks = (id) => {
        setExamId(id);
        dispatch(getManualExamsMarksRequest(id));
    };

    const sendGrade = (studentId, score) => {
        dispatch(
            setManualExamMarkRequest({
                student_id: studentId,
                exam_id: examId,
                score: score,
            })
        );
    };

    const lectures = useSelector((state) => state.lectures.lectures);
    const exams = useSelector((state) => state.superadminExams.exams);

    const lecOptions = lectures?.map((data) => {
        return { value: data.id, label: data.title };
    });

    const attendancesReport = useSelector(
        (state) => state.reports.attendancesReport
    );

    const [offset, setPage] = useState(0);

    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const colourStyles = {
        control: (styles) => ({
            ...styles,
            width: "100%",
            background: "#f5f5f5",
            color: "#690000",
            borderRadius: "16px",
        }),
        option: (styles) => ({ ...styles, color: "#690000" }),
        menu: (styles) => ({ ...styles, zIndex: 9999 }),
        menuList: (styles) => ({ ...styles, zIndex: 9999 }),
    };

    const headers = [
        { label: "name", key: "name" },
        { label: "phone", key: "phone" },
        // Only include grade and send_grade headers if an exam is selected
        ...(examId ? [
            { label: "grade", key: "grade" },
            { label: "send_grade", key: "send_grade" }
        ] : [])
    ];

    const Data = attendancesReport?.map((data, index) => {
        const studentMarks = marks.find((mark) => mark.student_id === data?.id);
        const baseData = {
            ...data,
            id: data?.id,
            name: data?.name,
            phone: data?.phone,
        };
        
        // Only add grade and send_grade fields if an exam is selected
        if (examId) {
            baseData.grade = (
                <Input
                    placeholder="Enter Grade"
                    _placeholder={{ color: "black" }}
                    defaultValue={studentMarks?.score || ""}
                    onChange={(e) => {
                        setScores(prev => ({
                            ...prev,
                            [data.id]: e.target.value
                        }));
                    }}
                    style={{
                        backgroundColor:
                            !studentMarks && !scores[data.id] ? "#FF7F7F" : "#90EE90",
                    }}
                />
            );
            baseData.send_grade = (
                <Button
                    onClick={(e) => {
                        sendGrade(data?.id, scores[data.id]);
                        e.target.innerText = "✔";
                    }}
                >
                    Send Grade
                </Button>
            );
        }
        
        return baseData;
    });

    const columns = [
        {
            Header: "اسم الطالب",
            accessor: "name",
        },
        {
            Header: "كود الطالب",
            accessor: "phone",
        },
        // Only include grade and send_grade columns if an exam is selected
        ...(examId ? [
            {
                Header: "الدرجة",
                accessor: "grade",
            },
            {
                Header: "ارسال الدرجة",
                accessor: "send_grade",
            }
        ] : [])
    ];

    return (
        <Layout>
            <div style={{ minHeight: "400px", marginTop: "100px" }}>
                <Text fontSize="24px" fontWeight="600" color="main_1">
                    رصد درجات السنتر
                </Text>
                <Flex
                    w="100%"
                    my="30px"
                    justifyContent="space-between"
                    alignItems="center"
                >

                    <Flex w="100%" justifyContent="space-between" alignItems="center" style={{ position: 'relative', zIndex: 1000 }}>
                        <Select
                            options={lecOptions}
                            isMulti={false}
                            onChange={(data) => {
                                setLecId(data?.value);
                            }}
                            styles={colourStyles}
                            placeholder="Select lecture"
                            
                        />
                        <Input
                            placeholder="Select Date and Time"
                            size="md"
                            type="datetime-local"
                            w="50%"
                            mx="8px"
                            onChange={(e) => {
                                const formatedDate = dayjs(e.target.value).format("YYYY-MM-DD");
                                setDate(formatedDate);
                            }}
                        />
                        {Data?.length !== 0 && (
                            <Select
                                options={exams.map((data) => {
                                    return { value: data.id, label: data.name };
                                })}
                                isMulti={false}
                                onChange={(data) => {
                                    getMarks(data?.value);
                                }}
                                styles={colourStyles}
                                placeholder="Select Exam"
                            />
                        )}
                    </Flex>
                </Flex>

                <CTable
                    selectedData={[]}
                    Columns={columns}
                    Data={Data}
                    path={"openModel"}
                    Actions
                    Title={``}
                    subTitle=""
                    btnTitle=""
                    placeHolder=""
                    noSearchBar={true}
                    noFilter={true}
                    footerBtnTitle
                    filterList
                    addButton
                    addButtonTitle=""
                    setPage={setPage}
                    setPerPage={setPerPage}
                    currentpage={pageNumber}
                    setPageNumber={setPageNumber}
                    noSecondSearchBar={true}
                    isLoading={false}
                    perPage={size}
                    totalPage={Math.ceil(10 / 50)}
                />
            </div>
        </Layout>
    );
};

export default AttendanceSimpleReport;
